import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/academy")({
  head: () => ({
    meta: [
      { title: "Consciousness Architecture Academy · KAfrequency" },
      { name: "description", content: "A living, interactive academy for consciousness. Learn your energetic blueprint through the interactive bodygraph, guided paths, and AI-supported study." },
      { property: "og:title", content: "Consciousness Architecture Academy · KAfrequency" },
      { property: "og:description", content: "Interactive bodygraphs, guided paths, and AI-supported study." },
      { property: "og:type", content: "website" },
    ],
  }),
  component: () => <Outlet />,
});
